import { createTheme } from "@mui/material/styles";
import { green, red } from "@mui/material/colors";
import "@fontsource/playfair-display";

const theme = createTheme({
  palette: {
    primary: {
      light: "#E7ECEF",
      main: "#272932",
      dark: "#363945",
    },
    secondary: {
      light: "#FFFFFF",
      main: "#FFFFFF",
      dark: "#FFFFFF",
    },
    warning: {
      main: "#ffc071",
      dark: "#ffb25e",
    },
    error: {
      light: red[50],
      main: red[500],
      dark: red[700],
    },
    success: {
      light: green[50],
      main: green[500],
      dark: green[700],
    },
    text: {
      primary: "#272932",
      secondary: "#272932",
    },
  },
  typography: {
    fontFamily: "'Roboto Condensed', sans-serif",
    fontSize: 14,
    fontWeightLight: 300, // Work Sans
    fontWeightRegular: 400, // Work Sans
    fontWeightMedium: 600, // Roboto Condensed
  },
});

export default theme;
